import * as React from 'react'
import Stack from '@mui/joy/Stack'
import EmailListItem from './EmailListItem'
import { EmailRecord } from './types'

interface EmailListProps {
    emails: EmailRecord[]
    onSelect: (email: EmailRecord) => void
    selectedId?: string
}

export default function EmailList({ emails, onSelect, selectedId }: EmailListProps) {
    return (
        <Stack spacing={0.5}>
            {emails.map((email) => (
                <EmailListItem
                    key={email.emailData.object.id}
                    email={email}
                    selected={selectedId === email.emailData.object.id}
                    onClick={() => onSelect(email)}
                />
            ))}
        </Stack>
    )
}
